import React, { useState } from 'react';

export default function Card({
  title,
  subtitle,
  image,
  body,
  cardClasses = '',
  tooltip,
  header,
  footer,
}) {
  const [hover, setHover] = useState(false);
  const tooltipStyle = {
    display: hover ? 'block' : 'none',
  };
  return (
    <div
      className={`card  ${cardClasses}`}
      style={{ minHeight: '35vh', maxHeight: '55vh' }}
    >
      {header && <div className="card-header">header</div>}
      <div className="card-body">
        {title && <h5 className="card-title">{title}</h5>}

        {subtitle && (
          <h6 className="card-subtitle mb-2 text-muted">{subtitle}</h6>
        )}
        {image && (
          <div>
            <div style={tooltipStyle}>{tooltip}</div>
            <img
              className="card-img-top"
              src={image}
              alt={title}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            ></img>
          </div>
        )}
        {body}
      </div>
      {footer && <div className="card-footer">footer</div>}
    </div>
  );
}
